import { styled } from 'styled-components'

export const CompanyNameWrapper = styled.div`
  width: calc(100% - 48px); // Minus favorite button and spacer width
`
